import React from "react";
import { Outlet } from "react-router-dom";
import { LoadingModalContext, useLoadingModal } from "@/shared/components/loading/loading-context";
import { LoadingModal } from "@/shared/components/loading/loading-modal";

export const BaseLayout = () => {
  // ローディング用コンテキスト
  const ctx = useLoadingModal();

  return (
    <LoadingModalContext.Provider value={ctx}>
      <Outlet />
      <LoadingModal />
    </LoadingModalContext.Provider>
  );
};
